import * as React from 'react';
import { Undo } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const UndoButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().undo().run()}
         isDisabled={!editor.can().undo()}
         icon={<Undo />}
         title={_js('Undo')}
         shortcut={'z'}
      ></TiptapButton>
   );
};
